import { useEffect, useState } from 'react';
import '../css/AvisoCookies.css';
import { lerConsentimento, salvarConsentimento, EVENTO_CONSENTIMENTO } from '../../consentimento';

// Faixa de aviso de cookies (LGPD). Aparece até a pessoa escolher
// "Aceitar" ou "Recusar". O Google Analytics só é ligado se ela aceitar.
const AvisoCookies = () => {
  const [visivel, setVisivel] = useState(() => lerConsentimento() === null);

  useEffect(() => {
    // Reaparece se a pessoa pedir para alterar a escolha (página de privacidade)
    const aoMudar = (e) => setVisivel(e.detail === null);
    window.addEventListener(EVENTO_CONSENTIMENTO, aoMudar);
    return () => window.removeEventListener(EVENTO_CONSENTIMENTO, aoMudar);
  }, []);

  if (!visivel) return null;

  const escolher = (valor) => {
    salvarConsentimento(valor);
    setVisivel(false);
  };

  return (
    <div className="aviso-cookies" role="region" aria-label="Aviso sobre cookies">
      <p>
        Usamos cookies para entender como o site é usado e melhorar a experiência das famílias.
        Nenhum dado é vendido ou usado para propaganda.{' '}
        <a href="/privacidade">Saiba mais</a>
      </p>
      <div className="aviso-cookies-botoes">
        <button type="button" className="aviso-cookies-recusar" onClick={() => escolher('recusado')}>
          Recusar
        </button>
        <button type="button" className="aviso-cookies-aceitar" onClick={() => escolher('aceito')}>
          Aceitar
        </button>
      </div>
    </div>
  );
};

export default AvisoCookies;
